import { __read, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { createContext } from '../../utils/createContext.js';
import { useLayoutSidebar } from '../LayoutSidebar/useLayoutSidebar.js';

var _a = __read(createContext({
    name: "LayoutScreen",
}), 2), useLayoutScreenContext = _a[0], LayoutScreenContext = _a[1];
var LayoutScreenConsumer = LayoutScreenContext.Consumer;
var LayoutScreenProvider = function (_a) {
    var children = _a.children, sidebarDefaultIsOpen = _a.sidebarDefaultIsOpen;
    var sidebar = useLayoutSidebar({ defaultIsOpen: sidebarDefaultIsOpen });
    var sidebarToggleButtonRef = useRef(null);
    var headerRef = useRef(null);
    return (jsx(LayoutScreenContext.Provider, __assign({ value: { sidebar: sidebar, header: { sidebarToggleButtonRef: sidebarToggleButtonRef, ref: headerRef } } }, { children: children })));
};

export { LayoutScreenConsumer, LayoutScreenProvider, useLayoutScreenContext };
//# sourceMappingURL=LayoutScreenContext.js.map
